import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DataCustomerBOperator, DataCustomerLeadOperator } from '../creazione-nuovo-customer/creazione-nuovo-customer-costants';

@Component({
  selector: 'app-customer-boperator',
  templateUrl: './customer-boperator.component.html',
  styleUrls: ['./customer-boperator.component.css']
})
export class CustomerBoperatorComponent implements OnInit {

  @Input() customerDto: DataCustomerLeadOperator;

  @Input() isDisabledFormBOperator: boolean;

  @Input() tendinaAgreements: any[];

  @Input() isModifica: boolean;

  @Output() changeCreationStepCustomerDataBoperatorItemEvent = new EventEmitter<string>();

  @Output() previousStepEvent = new EventEmitter<string>();

  @Output() updateCustomerDataBOperatorItemEvent = new EventEmitter<DataCustomerLeadOperator>();

  listBOperator: DataCustomerBOperator[] = [];
  ngOnDestroy: () => void;

  constructor(public toastr: ToastrManager) { }

  ngOnInit(): void {
    this.initializeFormCustomerDataBOperator();
  }

  initializeFormCustomerDataBOperator() {
    if (this.customerDto && this.customerDto.listBOperator && this.customerDto.listBOperator.length > 0) {
      this.listBOperator = this.customerDto.listBOperator;
    } else {
      let data: DataCustomerBOperator = {
        bOperatorGlobalCustomerId: "",
        leadOperatorGlobalCustomerId: "",
        masterFleetManagerId: "",
        bOperator: "",
        note: "",
        listCountry: []
      }
      this.listBOperator.push(data);
    }
  }



  backToStepLeadOperator() {
    this.updateCustomerBOperator();
    this.previousStepEvent.emit("customer-lead-operator");
  }

  goToStepCustomerCOuntry() {
    if(this.allValidBOperators()){
      this.updateCustomerBOperator();
      this.changeCreationStepCustomerDataBoperatorItemEvent.emit("customer-data-country");
    }
    
  }

  updateCustomerBOperator() {
    if (this.listBOperator.length > 0) {
      this.customerDto.listBOperator = this.listBOperator;
    }
    this.updateCustomerDataBOperatorItemEvent.emit(this.customerDto);
  }

  resetForm() {
    if (this.listBOperator.length > 0) {
      for (let elem of this.listBOperator) {
        elem.bOperatorGlobalCustomerId = '';
        elem.masterFleetManagerId = '';
        elem.note = '';
        elem.listCountry = [];
        elem.bOperator = "";
      }
    }
  }

  customerDataBOperatorFormDisabled() {
    let result: boolean = false;
    if (this.listBOperator.length == 0) {
      return true;
    }
    if (this.listBOperator.length > 0) {
      for (let elem of this.listBOperator) {
        if (!elem.bOperator || !elem.bOperatorGlobalCustomerId) {
          return true;
        }
      }
    }
    return result;
  }

  disabledForm() {
    return this.isDisabledFormBOperator;
  }

  addNewBOperator() {
    let data: DataCustomerBOperator = {
      bOperatorGlobalCustomerId: '',
      bOperator: '',
      note: '',
      masterFleetManagerId: '',
      listCountry: [],
      leadOperatorGlobalCustomerId: ''
    }
    this.listBOperator.push(data);
  }

  getBOperatorId(bOperator?: DataCustomerBOperator) {
    if (bOperator && !bOperator.bOperator) {
      return "B Operator";
    } else if (bOperator && bOperator.bOperator) {
      return "B Operator " + bOperator.bOperator;
    } else {
      return "";
    }
  }

  viewAddBOperator(bOperator: DataCustomerBOperator) {
    let index = this.listBOperator.indexOf(bOperator);
    if (index == (this.listBOperator.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  viewRemoveBOperator(bOperator: DataCustomerBOperator) {
    let index = this.listBOperator.indexOf(bOperator);
    let lastIndex: boolean = index == (this.listBOperator.length - 1);
    if (lastIndex && !this.customerBOperatorAlmenoUnCampoObbligatorioCompilato(bOperator)) {
      return true;
    } else {
      return false;
    }
  }

  customerBOperatorAlmenoUnCampoObbligatorioCompilato(bOperator: DataCustomerBOperator):boolean {
    let res:boolean=false;
    if(bOperator.bOperator || bOperator.bOperatorGlobalCustomerId){
      res=true;
    }
    return res;
  }

  removeBOperator(bOperator: DataCustomerBOperator) {
    let index = this.listBOperator.indexOf(bOperator);
    this.listBOperator.splice(index, 1);
  }

  viewAddBOperatorZeroBOperator() {
    if (this.listBOperator.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  onChange(newValue: string, bOperator: DataCustomerBOperator) {
    if(this.listBOperator && this.listBOperator.length>0){
      let bOp = this.listBOperator.find(element=> element.bOperatorGlobalCustomerId==bOperator.bOperatorGlobalCustomerId);
      if(bOp && bOp.listCountry && bOp.listCountry.length>0){
        for(let country of bOp.listCountry){
          country.operator=newValue;
          if(country.listAffiliate && country.listAffiliate.length>0){
            for(let affiliate of country.listAffiliate){
              affiliate.operator=newValue;
              if(affiliate.listDepartment && affiliate.listDepartment.length>0){
                for(let department of affiliate.listDepartment){
                  department.operator=newValue;
                }
              }
            }
          }
        }
      }
    }
    this.updateCustomerBOperator();
  }


  allValidBOperators(){
    let result: boolean = true;
    let lead: string = this.customerDto.leadOperator;
    let idlead: string = this.customerDto.leadOperatorGlobalCustomerId;
    for(let elem of this.listBOperator){
      if(elem.bOperator==lead){
        this.toastr.errorToastr('B Operator must be different from lead operator!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }

      if(elem.bOperatorGlobalCustomerId==idlead){
        this.toastr.errorToastr('B Operator ID must be different from lead operator ID!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      }
    }
    for (let i = 0; i < this.listBOperator.length; i++) {
      for (let j = i+1; j < this.listBOperator.length; j++) {
        if(this.listBOperator[i].bOperator==this.listBOperator[j].bOperator){
          this.toastr.errorToastr('B Operators must be different from each other!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        }
      }
    }
    return result;
  }

}
